import { promptSubscribeBot } from 'System/Preload/PromptSubscribeBot';
import { promptCreateShortcut } from 'System/Preload/PromptCreateShortcut';

export async function runAsyncPreloadTasks() {
    // Sequential execution.
    try {
        await promptSubscribeBot();
    } catch (e) {
        console.warn(e);
    }
    try {
        await promptCreateShortcut();
    } catch (e) {
        console.warn(e);
    }
}
